import { useMemo } from 'react';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function EditClonedLinkSlug({
  namespace,
  slug,
  handleSlugChange,
  showSlugCollision
}) {
  const validationMessage = useMemo(() => {
    if (showSlugCollision) return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cloneModal.slugCollision"
    });else if (!slug) return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cloneModal.validSlugRequired"
    });else return null;
  }, [showSlugCollision, slug]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormControl, {
      error: showSlugCollision || !slug,
      validationMessage: validationMessage,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cloneModal.meetingLink"
      }),
      required: true,
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cloneModal.tooltip.link"
      }),
      children: /*#__PURE__*/_jsx(TextInput, {
        value: slug,
        onChange: handleSlugChange,
        "data-selenium-test": "clone-meeting-slug",
        "data-test-id": "clone-slug-input"
      })
    }), /*#__PURE__*/_jsxs(View, {
      "data-selenium-test": "clone-link-preview",
      paddingBlockStart: "100",
      marginInlineStart: "100",
      as: "div",
      children: [namespace, "/", slug]
    })]
  });
}